import React from "react";
import classNames from "classnames";
import style from "./CheckboxInp.module.scss";

export const CheckboxInp: React.FC<{
  autoComplete?: string;
  id: string;
  name: string;
  className?: string;
  textualValue: string;
  isChecked: boolean;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
  required?: boolean;
  tryToChange: (change: { isChecked?: boolean; textualValue?: string }) => any;
}> = ({
  id,
  name,
  autoComplete,
  tryToChange,
  className,
  textualValue,
  isChecked,
  onFocus,
  onBlur,
  required,
}) => {
  const handleLocalChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const isChecked = e.target.checked;

    tryToChange({
      isChecked,
    });
  };

  return (
    <input
      id={id}
      name={name}
      autoComplete={autoComplete}
      className={classNames(style.ground, className)}
      type={"checkbox"}
      required={required}
      value={textualValue}
      checked={isChecked || false}
      onChange={handleLocalChange}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};
